'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._form_table_queryExportResponse_ = exports._form_table_normal_export_ = exports._form_table_big_export_ = undefined;

var _form_table_big_export_ = exports._form_table_big_export_ = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', (0, _requestOlympics2.default)({
              url: (0, _request.urlPrefix)() + '/form/table/big/export',
              method: 'POST',
              type: 'json',
              data: data
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function _form_table_big_export_(_x) {
    return _ref.apply(this, arguments);
  };
}();

var _form_table_normal_export_ = exports._form_table_normal_export_ = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', (0, _requestOlympics2.default)({
              url: (0, _request.urlPrefix)() + '/form/table/normal/export',
              method: 'POST',
              type: 'json',
              data: data
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function _form_table_normal_export_(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * @param {*} data sequenceNo/tablePropertyId/matterId
 * @returns
 */


var _form_table_queryExportResponse_ = exports._form_table_queryExportResponse_ = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', (0, _requestOlympics2.default)({
              url: (0, _request.urlPrefix)() + '/form/table/queryExportResponse',
              method: 'GET',
              data: data
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function _form_table_queryExportResponse_(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

var _requestOlympics = require('@ali/request-olympics');

var _requestOlympics2 = _interopRequireDefault(_requestOlympics);

var _request = require('../../adapter/request');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }